import { render, staticRenderFns } from "./product-detail-configurable.vue?vue&type=template&id=0082553b&"
import script from "./product-detail-configurable.vue.ts?vue&type=script&lang=ts&"
export * from "./product-detail-configurable.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports